import _define_property from "@swc/helpers/src/_define_property.mjs";
import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import { Box, Tooltip, factory, useProps } from "@components/mantine";
import { SourceCategory } from "@core/api";
import { CloudSize16Px, CloudSize24Px, CloudSize32Px, CrawlingBotSize16Px, CrawlingBotSize24Px, CrawlingBotSize32Px, DatabaseSize16Px, DatabaseSize24Px, DatabaseSize32Px, PushSize16Px, PushSize24Px, PushSize32Px } from "@coveord/plasma-react-icons";
import { Locales } from "../../../strings/Locales.js";
import { useSourceIdentityContext } from "../SourceIdentityContext.js";
var _obj, _obj1, _obj2;
var CATEGORY_IMAGE_MAPPINGS = {
    sm: (_obj = {}, _define_property(_obj, SourceCategory.CLOUD, CloudSize16Px), _define_property(_obj, SourceCategory.ON_PREM, DatabaseSize16Px), _define_property(_obj, SourceCategory.CRAWLING_MODULE, CrawlingBotSize16Px), _define_property(_obj, SourceCategory.PUSH, PushSize16Px), _obj),
    md: (_obj1 = {}, _define_property(_obj1, SourceCategory.CLOUD, CloudSize24Px), _define_property(_obj1, SourceCategory.ON_PREM, DatabaseSize24Px), _define_property(_obj1, SourceCategory.CRAWLING_MODULE, CrawlingBotSize24Px), _define_property(_obj1, SourceCategory.PUSH, PushSize24Px), _obj1),
    lg: (_obj2 = {}, _define_property(_obj2, SourceCategory.CLOUD, CloudSize32Px), _define_property(_obj2, SourceCategory.ON_PREM, DatabaseSize32Px), _define_property(_obj2, SourceCategory.CRAWLING_MODULE, CrawlingBotSize32Px), _define_property(_obj2, SourceCategory.PUSH, PushSize32Px), _obj2)
};
var defaultProps = {
    disabled: false,
    showTooltip: false,
    size: "md"
};
export var SourceIdentityCategoryIcon = factory(function(props, ref) {
    var _ref = useProps("SourceIdentityCategoryIcon", defaultProps, props), disabled = _ref.disabled, showTooltip = _ref.showTooltip, size = _ref.size, others = _object_without_properties(_ref, [
        "disabled",
        "showTooltip",
        "size"
    ]);
    var _$ref = useSourceIdentityContext(), category = _$ref.category, getStyles = _$ref.getStyles;
    if (!category) {
        return null;
    }
    var IconComponent = CATEGORY_IMAGE_MAPPINGS[size][category];
    return /*#__PURE__*/ _jsx(Tooltip, {
        label: Locales.format("SourceIdentity.CategoryIcon.".concat(category, ".tooltip")),
        disabled: !showTooltip,
        children: /*#__PURE__*/ _jsx(Box, _object_spread_props(_object_spread({
            ref: ref,
            "data-size": size
        }, getStyles("categoryIcon"), others), {
            children: /*#__PURE__*/ _jsx(IconComponent, {
                "data-disabled": disabled
            })
        }))
    });
});
SourceIdentityCategoryIcon.displayName = "@resourceIdentity/source/SourceIdentity/CategoryIcon";

//# sourceMappingURL=SourceIdentityCategoryIcon.js.map